import { createAction } from 'redux-actions';
import { VISITOR_EMAIL_UPDATED } from '../constants/actionTypes';
export const visitorEmailUpdated = createAction(VISITOR_EMAIL_UPDATED, ({
  threadId,
  visitorEmail
}) => ({
  threadId,
  visitorEmail
}));